<template>
  <div class="admin-layout">
    <aside class="admin-sidebar">
      <div class="sidebar-brand">
        <span class="brand-logo">Boris Bags</span>
        <span class="brand-sub">管理后台</span>
      </div>

      <nav class="sidebar-nav">
        <router-link
          v-for="item in navItems"
          :key="item.to"
          :to="item.to"
          class="nav-item"
          active-class="active"
        >
          <span class="nav-icon" aria-hidden="true">{{ item.icon }}</span>
          <span class="nav-label">{{ item.label }}</span>
        </router-link>
      </nav>
    </aside>

    <div class="admin-main">
      <header class="admin-topbar">
        <h1 class="topbar-title">{{ pageTitle }}</h1>
        <div class="topbar-actions">
          <div class="topbar-user">
            <span class="user-name">{{ user?.username || '—' }}</span>
            <span class="user-role">{{ user?.role || '' }}</span>
            <button type="button" class="btn-logout" @click="handleLogout">退出登录</button>
          </div>
        </div>
      </header>

      <div class="admin-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { fetchCurrentUser } from '@/api/auth'
import { clearAuth, getAdminUser } from '@/utils/adminAuth'

const navItems = [
  { to: '/admin/banners', label: '首页轮播图', icon: '▥' },
  { to: '/admin/catalogue', label: '产品分类管理', icon: '▤' },
  { to: '/admin/products', label: '商品管理', icon: '▣' },
  { to: '/admin/news', label: '新闻中心', icon: '▦' },
  { to: '/admin/messages', label: '咨询消息', icon: '✉' }
]

export default {
  name: 'AdminLayout',
  data() {
    return {
      navItems,
      user: getAdminUser()
    }
  },
  computed: {
    pageTitle() {
      return this.$route.meta.adminTitle || '管理后台'
    }
  },
  async created() {
    try {
      const res = await fetchCurrentUser()
      if (res.code === 0 && res.data) {
        this.user = res.data
      }
    } catch {
      clearAuth()
      this.$router.replace('/admin/login')
    }
  },
  methods: {
    handleLogout() {
      clearAuth()
      this.$router.replace('/admin/login')
    }
  }
}
</script>

<style scoped>
.admin-layout {
  display: flex;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: #f1f5f9;
}

.admin-sidebar {
  flex-shrink: 0;
  width: 220px;
  display: flex;
  flex-direction: column;
  background: #0f172a;
  color: #fff;
}

.sidebar-brand {
  padding: 20px 18px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.brand-logo {
  display: block;
  font-size: 16px;
  font-weight: 700;
}

.brand-sub {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #94a3b8;
}

.sidebar-nav {
  flex: 1;
  padding: 16px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 14px;
  font-size: 14px;
  color: #cbd5e1;
  text-decoration: none;
  border-radius: 8px;
  transition: background 0.2s, color 0.2s;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}

.nav-item.active {
  background: rgba(13, 148, 136, 0.25);
  color: #99f6e4;
  font-weight: 600;
}

.nav-icon {
  width: 20px;
  text-align: center;
  font-size: 14px;
  opacity: 0.9;
}

.admin-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.admin-topbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 24px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.topbar-title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #0f172a;
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.topbar-user {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #475569;
}

.user-name {
  font-weight: 600;
  color: #0f172a;
}

.user-role {
  padding: 2px 8px;
  font-size: 11px;
  background: #ecfdf5;
  color: #0f766e;
  border-radius: 6px;
}

.btn-logout {
  padding: 6px 12px;
  font-size: 13px;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
}

.btn-logout:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.admin-content {
  flex: 1;
  padding: 24px;
  overflow: auto;
}

@media (max-width: 768px) {
  .admin-sidebar {
    width: 72px;
  }

  .brand-sub,
  .nav-label {
    display: none;
  }

  .sidebar-brand {
    padding: 16px 8px;
    text-align: center;
  }

  .brand-logo {
    font-size: 11px;
  }

  .nav-item {
    justify-content: center;
    padding: 12px 8px;
  }

  .topbar-user .user-name,
  .topbar-user .user-role {
    display: none;
  }
}
</style>
